"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Doors.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Doors = function Doors(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 190 191.2"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Doors Icon"), _react2.default.createElement("g", {
    className: "doors",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "door",
    d: "M126.3 1L0 0v129l3.8.2a74.07 74.07 0 0 1 27.5 8.5c18.1 10.1 27.4 26.8 27.7 49.5v4h131V93.4zm-4.2 8.1l50.5 73.2H8V8.1zM182 183.3H66.8c-1.7-29.6-18-44.8-31.7-52.5a80.93 80.93 0 0 0-27.2-9.1V90.2H178l3.9 5.7v87.4h.1z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "handle",
    d: "M48.7 104.2h29v8h-29z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = Doors;